import "./music.css";
import React, { useEffect, useState } from "react";
import Song from "./Song/Song";
import SearchBox from "../search-box/search-box";
// import tracksArray from './mySongs/tracksArray'
//----------------------------------------------------------------------------------------
const Music = ({ arr, imgLink }) => {
  const [flags, setFlags] = useState([]);

  //----------------------------------------------------------------------------------------
  useEffect(() => {
    setFlags([
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ]);
  }, []);
  //----------------------------------------------------------------------------------------
  const updateFlag = (id, flag) => {
    setFlags(flags.map((s, index) => (index === id ? flag : false)));
  };
  //----------------------------------------------------------------------------------------
  const stopOthers = (id) => {
    arr.map((s) => (s.id !== id ? s.audio.pause() : ""));
    setFlags(flags.map((s, index) => (index !== id ? false : true)));
  };
  //----------------------------------------------------------------------------------------
  const getFlag = (id) => {
    return flags[id];
  };


  const [filteredSuras, setFilteredSuras] = useState(arr);
  const searchHandler = (e) => {
    const searchWord = e.target.value;
    const newFilter = arr.filter((s) =>
      s.name.toLowerCase().includes(searchWord.toLowerCase())
    );
    setFilteredSuras(newFilter);
  };

  //----------------------------------------------------------------------------------------
  return (
    <div className="MusicContainer">
      <div>
        {imgLink ? (
          <div className="DivImg">
            <img
              className="songImg"
              src={imgLink}
              alt={imgLink}
              key={imgLink}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div >

        <SearchBox
          group={filteredSuras} searchHandler={searchHandler}
        />

        <div className="allSongsDiv">
          {filteredSuras?.map((s) => (
            <Song
              key={s.id}
              flag={getFlag(s.id)}
              song={s}
              stopOthers={stopOthers}
              updateFlag={updateFlag}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default Music;
